import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
	name: 'cpKeys'
})
export class KeysPipe implements PipeTransform {
	transform(obj:Object) {
		return Object.keys(obj);
	}
}
